import { ApiClient } from './ApiClient';

export interface Language {
    name: string;
    language: string;
    code: string;
    twoLetterISO: string;
    url: string;
    selected: boolean;
}

export interface Country {
    countryTitle: string;
    multilingual: boolean;
    active: boolean;
    countryCode: string | null;
    code: string;
    countrySuggestionTitle: string | null;
    countrySuggestionText: string | null;
    countrySuggestionLinkText: string | null;
    languages: Language[];
}

export class CountriesApi {
    private apiClient: ApiClient;

    constructor() {
        this.apiClient = new ApiClient('/api/countries');
    }

    public async getCountries(params: { url?: string } = {}): Promise<Country[]> {
        const json = await this.apiClient.get<{ countries: Country[] }>('GetCountries', params);

        return json.countries;
    }
}

// Export a single shared instance
export const countriesApi = new CountriesApi();